import React from "react";
import MuiLoadingButton from "@mui/lab/LoadingButton";

const LoadingButton = ({
  float = "right",
  fullWidthMobile = false,
  loading = false,
  disabled = loading,
  backgroundColor = "#107DE2",
  ...props
}) => (
  <MuiLoadingButton
    {...props}
    variant="contained"
    color="primary"
    sx={{
      fontSize: "16px",
      float: float,
      fontWeight: 500,
      fontStyle: "normal",
      backgroundColor: loading ? backgroundColor : backgroundColor,
      marginTop: "16px",
      marginBottom: "16px",
      color: "#FFF",
      borderRadius: 0,
      width: "100%",
      "@media (min-width: 600px)": {
        width: "auto",
      },
      "&:hover": {
        backgroundColor: loading ? backgroundColor : backgroundColor,
        borderRadius: 0,
      },
    }}
    disabled={disabled}
    loading={loading}
  >
    {props.children}
  </MuiLoadingButton>
);

export default LoadingButton;
